import Image from "next/legacy/image"
import styles from "./contacts.module.css"
import Block from "@/components/wrappers/block"
import useStrings from "@/lib/hooks/useStrings"

export default function Contacts({ block }) {
  const { persons } = block.attrs
  const { contactPerson, contactPersons } = useStrings()

  if (block.attrs.length === 0 || persons.length === 0) {
    return null
  }

  const heading = persons.length === 1 ? contactPerson : contactPersons

  return (
    <Block block={block} width="column" className={styles.contacts}>
      <h5>{heading}</h5>
      <div>
        {persons.map((person, index) => {
          return (
            <Person
              key={`person-${index}`}
              data={person}
              {...{ contactPerson }}
            />
          )
        })}
      </div>
    </Block>
  )
}

const Person = ({ data, contactPerson }) => {
  const { avatar, email, name, position, phone } = data

  return (
    <div className="flex flex-row items-start mt-5">
      {avatar?.url && (
        <figure className="flex-none mr-5 overflow-hidden rounded-full w-icon-xxl h-icon-xxl">
          <Image
            className={`object-cover object-center w-full h-full`}
            src={avatar.url}
            alt={avatar.alt}
            width={avatar.width}
            height={avatar.height}
            sizes="96px"
          />
        </figure>
      )}

      <div className="flex flex-col content-wrapper">
        <span className="text-xs font-bold uppercase tracking-widest leading-4.5">
          {contactPerson}
        </span>
        <strong className="py-1 text-xl font-medium">{name}</strong>
        <span className="text-lg">{position}</span>
        <a
          className="block text-lg underline text-good-green-100"
          href={`tel:${phone}`}>
          {phone}
        </a>
        <a
          className="block text-lg underline text-good-green-100 email"
          href={`mailto:${email}`}>
          {email}
        </a>
      </div>
    </div>
  )
}
